/**
 * @generated SignedSource<<d677f951b80560e9535d4c5324decc32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyMobileNav_filters$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"BuyMobileNavRefineMenuFilters_filters">;
  readonly " $fragmentType": "BuyMobileNav_filters";
}>;
export type BuyMobileNav_filters$key = ReadonlyArray<{
  readonly " $data"?: BuyMobileNav_filters$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyMobileNav_filters">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "BuyMobileNav_filters",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyMobileNavRefineMenuFilters_filters"
    }
  ],
  "type": "SearchBrowseFilter",
  "abstractKey": null
};

(node as any).hash = "0423fd0e7df01cec0682fdd8445c530a";

export default node;
